import {
  INVOICE_VERIFY_LIST,
  INVOICE_VERIFY_DETAIL,
  INVOICE_VERIFY,
  INVOICE_REUPLOAD,
  INVOICE_VERIFIED_LIST,
  INVOICE_PTR_UPDATE,
  AI_VERIFIED_INVOICE_LIST,
  AI_VERIFIED_INVOICE_DETAIL,
  VERIFIED_INVOICE_LIST,
  VERIFIED_INVOICE_DETAIL,
  FLAGGED_INVOICE_LIST,
  FLAGGED_INVOICE_DETAIL,
  PENDING_INVOICE_LIST,
  PENDING_INVOICE_DETAIL,
  REJECTED_INVOICE_LIST,
  REJECTED_INVOICE_DETAIL,
  VERIFY_PENDING_INVOICE_DETAIL,
  REJECT_PENDING_INVOICE_DETAIL,
  PRODUCT_BATCH_PRICING_DROPDOWN,
  UPDATE_PRODUCT_PTR,
  FLAG_AIVERIFIED_INVOICE_DETAIL,
} from "./types";

export const invoiceVerifyList = (data, onSuccess, onError) => {
  return {
    type: INVOICE_VERIFY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const invoiceVerifiedList = (data, onSuccess, onError) => {
  return {
    type: INVOICE_VERIFIED_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const invoiceVerifyDetail = (id, onSuccess, onError) => {
  return {
    type: INVOICE_VERIFY_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const invoiceVerify = (data, onSuccess, onError) => {
  return {
    type: INVOICE_VERIFY,
    data,
    onSuccess,
    onError,
  };
};

export const invoiceReupload = (data, onSuccess, onError) => {
  return {
    type: INVOICE_REUPLOAD,
    data,
    onSuccess,
    onError,
  };
};

export const invoiceUpdatePtr = (data, onSuccess, onError) => {
  return {
    type: INVOICE_PTR_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const aiVerifiedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: AI_VERIFIED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const aiVerifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: AI_VERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const verifiedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: VERIFIED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const verifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: VERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const flaggedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: FLAGGED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const flaggedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: FLAGGED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const pendingInvoiceList = (data, onSuccess, onError) => {
  return {
    type: PENDING_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const pendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const rejectedInvoiceList = (data, onSuccess, onError) => {
  return {
    type: REJECTED_INVOICE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const rejectedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: REJECTED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const verifyPendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: VERIFY_PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const rejectPendingInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: REJECT_PENDING_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};

export const productBatchPricingDropDown = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_BATCH_PRICING_DROPDOWN,
    data,
    onSuccess,
    onError,
  };
};

export const updateProductPtr = (data, onSuccess, onError) => {
  return {
    type: UPDATE_PRODUCT_PTR,
    data,
    onSuccess,
    onError,
  };
};

export const flagAiVerifiedInvoiceDetail = (data, onSuccess, onError) => {
  return {
    type: FLAG_AIVERIFIED_INVOICE_DETAIL,
    data,
    onSuccess,
    onError,
  };
};
